import { mockResponse, request, isMockMode } from './client.js';
import { normalizeSavedCards } from '../utils/savedCards.js';

/**
 * 會員常用代打卡片 API（owner-scoped，需登入）。
 * REACT_APP_USE_MOCK_SAVEDCARDS=false 走真實後端。
 *
 * SavedCardDto：{ id, cardName, account, note, isDefault }
 * 遊戲卡密碼只保留在管理員的 Google Sheet，不會回傳到會員瀏覽器。
 */

let _cards = [
  { id: 1, cardName: '我的主卡', account: 'player@michidart.tw', note: '主帳號', isDefault: true },
  { id: 2, cardName: '阿賢的卡', account: 'ken.dart@gmail.com', note: '常一起約鏢', isDefault: false },
];
let _nextId = 3;
const clone = (x) => JSON.parse(JSON.stringify(x));

export function getSavedCards() {
  if (!isMockMode('savedcards')) {
    return request('/api/saved-cards').then(normalizeSavedCards);
  }
  return mockResponse(() => normalizeSavedCards(_cards.map(clone)));
}

export function createSavedCard(payload) {
  if (!isMockMode('savedcards')) return request('/api/saved-cards', { method: 'POST', body: payload });
  return mockResponse(() => {
    // 目前沒有任何預設卡 → 這張（等於第一張）自動設為預設
    const card = { id: _nextId++, ...payload, isDefault: !_cards.some(c => c.isDefault) };
    _cards = [card, ..._cards];
    return clone(card);
  });
}

export function setDefaultCard(id) {
  if (!isMockMode('savedcards')) return request(`/api/saved-cards/${id}/default`, { method: 'PATCH' });
  return mockResponse(() => {
    _cards = _cards.map(c => ({ ...c, isDefault: c.id === id }));
    return clone(_cards.find(c => c.id === id));
  });
}

export function updateSavedCard(id, payload) {
  if (!isMockMode('savedcards')) return request(`/api/saved-cards/${id}`, { method: 'PUT', body: payload });
  return mockResponse(() => {
    const idx = _cards.findIndex(c => c.id === id);
    if (idx === -1) throw new Error('找不到該卡片');
    _cards[idx] = { ..._cards[idx], ...payload };
    return clone(_cards[idx]);
  });
}

export function deleteSavedCard(id) {
  if (!isMockMode('savedcards')) return request(`/api/saved-cards/${id}`, { method: 'DELETE' });
  return mockResponse(() => {
    const removed = _cards.find(c => c.id === id);
    _cards = _cards.filter(c => c.id !== id);
    // 刪掉的是預設且還有其他卡 → 最新一張（清單第一筆）自動升為預設
    if (removed?.isDefault && _cards.length > 0) {
      _cards = _cards.map((c, i) => ({ ...c, isDefault: i === 0 }));
    }
    return null;
  });
}
